import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";
import session from "../services/session";
import AutocompleteObject from '../components/Shared/AutocompleteObject';


/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default{

    props: ['show', 'article', 'quantity'],

    data() {
        return {
            locale: LocService,
            title: '',
            subTitle: '',
            hasError: null,
            isLoading: false,
            showQrCodeScanner: false,
            visibleReturnedAmount: false,
            visibleChangeArticle: false,
            selectedButton: 'PLUS',
            valueEur: 0,
            valueRsd: 0,
            returnedAmountEur: 0,
            returnedAmountRsd: 0,
            articleIdForChange: '',
            changeName: '',
            changeCode: '',
            articleId: 0,
            includeInSchedule: true,
            sentByPost: false,
            comment: '',
            ramMemories: ['2','3','4','6','8','12','16','24','32'],
            romMemories: ['16','32','64','128','256','512','1024'],
            selectedArticleForChangeIndex: -1,
            selectedArticleForChange: {
                changeName: '',
                changeCode: '',
                changeCategory: '',
                changeSubCategory: '',
                changeComment: '',
                changeColor: '',
                changeRamMemory: '',
                changeRomMemory: '',
                changeShortDescription: '',
            },
            allCategories: [],
            selectedSubCategories: [],
            categories: [],
            articlesForChange: [],
            colorsByCategory: [],
            newSelectedCategory: null,
            newSelectedSubCategory: null,
            visibleCategory: true,
            visibleSubCategory: true,


            imeiLabels: [LocService.t('label_a_code'), LocService.t('label_a_code_serial')],
            imeiType: 'number',
            selectedImeiItem: LocService.t('label_a_code'),
        };
    },

    watch: {
        'selectedArticleForChange.changeColor'(newVal, oldVal) {
            this.$topnavbar.$emit('newItemSetToAutocompleteColorAutoComplete', newVal);
        },
        selectedArticleForChange: function (val, oldVal){
            if(this.selectedArticleForChangeIndex > -1){
                this.articlesForChange[this.selectedArticleForChangeIndex].changeName = val.changeName
                this.articlesForChange[this.selectedArticleForChangeIndex].changeCode = val.changeCode
                this.articlesForChange[this.selectedArticleForChangeIndex].changeComment = val.changeComment
                this.articlesForChange[this.selectedArticleForChangeIndex].changeColor = val.changeColor
                this.articlesForChange[this.selectedArticleForChangeIndex].changeRamMemory = val.changeRamMemory
                this.articlesForChange[this.selectedArticleForChangeIndex].changeRomMemory = val.changeRomMemory
                this.articlesForChange[this.selectedArticleForChangeIndex].changeShortDescription = val.changeShortDescription
            }
        },
        show: function(val, oldVal) {
            if(val === true){
                if(session.getCategories() != null){
                    this.allCategories = session.getCategories();
                    this.categories = this.allCategories.filter(e => e.parentCategory == null).map(m => m.name)
                }else {
                    this.loadCategories();
                }
                this.articleId = this.article.id;
                this.title = this.article.name;
                this.comment = this.article.comment;
                if(this.article.purchasePrice != null){
                    this.subTitle = LocService.t('label_a_purchase_price') + ': ' + this.article.purchasePrice + ' €';
                }else{
                    this.subTitle = LocService.t('label_a_purchase_price') + ': 0 €'
                }
            }
        },
        amount: function(val, oldVal) {
            this.hasError = '';
        },

        newSelectedCategory: function (val, old){
            this.visibleCategory = val == null
            if(val != null){
                this.selectedSubCategories = this.allCategories.filter(e => e.parentCategory === val).map(m => m.name);
                let foundCategory = this.allCategories.filter(e => e.name === val)
                if(foundCategory.length > 0){
                    let cat = foundCategory[0];
                    console.log(cat)
                    if(cat.color == null || cat.color.length === 0){
                        this.colorsByCategory = []
                    }else{
                        let c = cat.color.split(";").filter(s=> s != null && s.length > 0)
                        this.colorsByCategory = c;
                    }

                }else{
                    this.colorsByCategory = []
                }
            }else{
                this.selectedSubCategories = [];
                this.colorsByCategory = []
            }
            if(this.selectedArticleForChangeIndex > -1){
                this.articlesForChange[this.selectedArticleForChangeIndex].changeCategory = val
            }
        },

        newSelectedSubCategory: function (val, old){
            this.visibleSubCategory = val == null
            if(this.selectedArticleForChangeIndex > -1){
                this.articlesForChange[this.selectedArticleForChangeIndex].changeSubCategory = val
            }
        },
    },

    components: { AutocompleteObject},
    methods: {
        close() {
            this.$topnavbar.$emit('closeSellBuyArticle')
            this.reset();
        },
        successUpdate(data){
            this.$topnavbar.$emit('successSellBuyArticle', data)
        },
        onTabClicked: onTabClicked,
        addToStock: addToStock,
        removeFromStock: removeFromStock,
        reset: reset,
        onSelectImeiType : onSelectImeiType,
        getChipClassImei: getChipClassImei,
        isSelectedImei: isSelectedImei,
        isSelectedColor: isSelectedColor,
        getColorClass: getColorClass,
        loadCategories: loadCategories,
        getChipClassCategory: getChipClassCategory,
        isSelectedCategory: isSelectedCategory,
        deleteCategory: deleteCategory,
        getChipClassSub: getChipClassSub,
        isSelectedSub: isSelectedSub,
        deleteSubCategory: deleteSubCategory,
        onClickSubCategory: onClickSubCategory,
        addArticleForChange: addArticleForChange,
        deleteArticleForChange: deleteArticleForChange,
        selectItemForChange: selectItemForChange,


        save: save,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--large'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            return this.isMobile()
                ? 'background-color: #1C242D; color: #ffffff; max-height: 90vh; overflow-y: auto;'
                : 'background-color: #1C242D; color: #ffffff; max-height: 90vh; overflow-y: auto;';
            // if(this.isMobile()){
            //     return 'background-color: #1C242D; color: #ffffff;'
            // }else {
            //     return 'background-color: #1C242D; color: #ffffff; '
            // }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        },
        validateEurInput(event) {
            if (event.target.value < 0) {
                event.target.value = 0;
                this.valueEur = 0;
            }
        },
        validateRsdInput(event) {
            if (event.target.value < 0) {
                event.target.value = 0;
                this.valueRsd = 0;
            }
        },
        validateReturnedEurInput(event) {
            if (event.target.value < 0) {
                event.target.value = 0;
                this.returnedAmountEur = 0;
            }
        },
        validateReturnedRsdInput(event) {
            if (event.target.value < 0) {
                event.target.value = 0;
                this.returnedAmountRsd = 0;
            }
        }
    }
}

function selectItemForChange(index){
    this.selectedArticleForChangeIndex = index
    this.selectedArticleForChange = this.articlesForChange[index]
    this.visibleChangeArticle = true;
    this.newSelectedCategory = this.selectedArticleForChange.changeCategory
    this.newSelectedSubCategory = this.selectedArticleForChange.changeSubCategory
}

function addArticleForChange() {
    this.articlesForChange.push({
        changeName: '',
        changeCode: '',
        changeCategory: '',
        changeSubCategory: '',
        changeComment: '',
        changeColor: '',
        changeRamMemory: '',
        changeRomMemory: '',
        changeShortDescription: '',
    })
}

function deleteArticleForChange(index){
    this.articlesForChange.splice(index, 1);
    this.selectedArticleForChange = {
        changeName: '',
        changeCode: '',
        changeCategory: '',
        changeSubCategory: '',
        changeComment: '',
        changeColor: '',
        changeRamMemory: '',
        changeRomMemory: '',
        changeShortDescription: '',
    };
    this.selectedArticleForChangeIndex = -1
    this.visibleChangeArticle = false;
}

function onTabClicked(tab){
    this.selectedButton = tab;
}

function reset() {
   this.valueEur = 0;
   this.valueRsd = 0;
   this.returnedAmountEur = 0;
   this.returnedAmountRsd = 0;
   this.articleIdForChange = '';
   this.visibleReturnedAmount = false;
   this.visibleChangeArticle = false;
   this.articlesForChange = []
   this.selectedArticleForChange = {
        changeName: '',
        changeCode: '',
        changeCategory: '',
        changeSubCategory: '',
        changeComment: '',
        changeColor: '',
        changeRamMemory: '',
        changeRomMemory: '',
        changeShortDescription: '',
    };
   this.selectedArticleForChangeIndex = -1
   this.visibleChangeArticle = false;
   this.comment = ''
   this.deleteCategory();
}

function save(){
    if(this.quantity === 0){
        this.removeFromStock();
    }else{
        this.addToStock();
    }
}


function addToStock(){
    // if(this.selectedImeiItem === LocService.t('label_a_code')){
    //     if (this.changeCode.length === 15 && /^\d+$/.test(this.changeCode)) {
    //         // console.log("String ima tačno 15 cifara i sve su brojevi.");
    //     } else {
    //         swal( LocService.t('label_error'), LocService.t('label_imei_error'), 'error')
    //         return;
    //     }
    // }else{
    //     if (this.changeCode.length === 0){
    //         swal( LocService.t('label_error'), LocService.t('label_serial_number_error'), 'error')
    //         return;
    //     }
    // }
    let _self = this;
    var valueRsd = this.selectedButton === 'MINUS' ? this.valueRsd * -1 : this.valueRsd;
    var valueEur = this.selectedButton === 'MINUS' ? this.valueEur * -1 : this.valueEur;
    let model = {
        id: this.articleId,
        stockNumber: 1,
        moneyRsdIn: valueRsd,
        moneyEurIn: valueEur,
        comment: this.comment,
        returnedAmountEur: this.returnedAmountEur,
        returnedAmountRsd: this.returnedAmountRsd,
        articlesForChange: this.articlesForChange,
        includeInSchedule: this.includeInSchedule,
        sentByPost: this.sentByPost,

    }
    this.isLoading = true;
    AdminApiService.updateArticleStock(model)
        .then((response) => {
            // _self.load()
            // swal.close()
            _self.reset();
            _self.successUpdate();
            this.isLoading = false;
        })
        .catch(error => {
            console.log(error)
            this.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function removeFromStock(){
    // if(this.selectedImeiItem === LocService.t('label_a_code')){
    //     if (this.changeCode.length === 15 && /^\d+$/.test(this.changeCode)) {
    //         // console.log("String ima tačno 15 cifara i sve su brojevi.");
    //     } else {
    //         swal( LocService.t('label_error'), LocService.t('label_imei_error'), 'error')
    //         return;
    //     }
    // }else{
    //     if (this.changeCode.length === 0){
    //         swal( LocService.t('label_error'), LocService.t('label_serial_number_error'), 'error')
    //         return;
    //     }
    // }
    let _self = this;
    var valueRsd = this.selectedButton === 'MINUS' ? this.valueRsd * -1 : this.valueRsd;
    var valueEur = this.selectedButton === 'MINUS' ? this.valueEur * -1 : this.valueEur;
    let model = {
        id: this.articleId,
        stockNumber: 0,
        moneyRsdIn: valueRsd,
        moneyEurIn: valueEur,
        comment: this.comment,
        returnedAmountEur: this.returnedAmountEur,
        returnedAmountRsd: this.returnedAmountRsd,
        articlesForChange: this.articlesForChange,
        includeInSchedule: this.includeInSchedule,
        sentByPost: this.sentByPost
    }
    this.isLoading = true;

    AdminApiService.updateArticleStock(model)
        .then((response) => {

            this.isLoading = false;
            _self.reset();
            let articleChanged = response.data.articleIds != null ? LocService.t('label_article_changed') + ': ' + response.data.articleIds : ''
            _self.successUpdate(articleChanged);

        })
        .catch(error => {
            console.log(error)
            this.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getChipClassImei(item){
    if(this.selectedImeiItem === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedImei(item){
    return this.selectedImeiItem === item
}

function onSelectImeiType(item){
    this.selectedImeiItem = item;
    this.changeCode = ''
    if(this.selectedImeiItem === LocService.t('label_a_code')){
        this.imeiType = 'number'
    }else{
        this.imeiType = 'text'
    }
}

function loadCategories() {
    let _self = this;

    AdminApiService.getArticleCategories()
        .then((response) => {
            _self.allCategories = response.data;
            session.saveArticleCategories(_self.allCategories)
            _self.categories =  _self.allCategories.filter(e => e.parentCategory == null).map(m => m.name)
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getChipClassCategory(item){
    if(this.newSelectedCategory === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedCategory(item){
    return this.newSelectedCategory === item
}

function deleteCategory(){
    this.newSelectedCategory = null;
    this.newSelectedSubCategory = null;
}


function getChipClassSub(item){
    if(this.newSelectedSubCategory === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}


function isSelectedSub(item){
    return this.newSelectedSubCategory === item
}

function deleteSubCategory(){
    this.newSelectedSubCategory = null;
}

function onClickSubCategory(item){
    this.newSelectedSubCategory = item;
}

function isSelectedColor(item){
    return this.selectedArticleForChange.changeColor === item
}

function getColorClass(item){
    if(this.selectedArticleForChange.changeColor === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}


// WEBPACK FOOTER //
// ./src/modals/SellBuyArticle.js